// src/services/AttendanceService.js
import { apiService } from './apiService';

export function getAttendanceService(data) {
  return apiService({
    method: 'POST',
    url: '/attendance/data',
    data,
    onSuccess: (dispatch, res) => {},
    onFailure: () => {},
  });
}

export function getByIdAttendanceService(id) {
  return apiService({
    method: 'GET',
    url: '/attendance/' + id,
    onSuccess: (dispatch, res) => {},
    onFailure: () => {},
  });
}

export function createAttendanceService(data) {
  return apiService({
    method: 'POST',
    url: '/attendance',
    data,
    onSuccess: (dispatch, res) => {},
    onFailure: () => {},
  });
}

export function updateAttendanceService(id, data) {
  return apiService({
    method: 'PUT',
    url: '/attendance/' + id,
    data,
    onSuccess: (dispatch, res) => {},
    onFailure: () => {},
  });
}

export function deleteAttendanceService(id) {
  return apiService({
    method: 'DELETE',
    url: '/attendance/' + id,
    onSuccess: (dispatch, res) => {},
    onFailure: () => {},
  });
}

